import { useTranslations } from "use-intl";
import { useSettingsSupplier } from "@/app/Suppliers/Utils/useSettingsSupplier";
import { SettingCard } from "@/app/Settings/Settings/Components/SettingFormCard";
import { NoSupplierEmptyState } from "@/app/Settings/Settings/Components/NoSupplierEmptyState";
import { ActivityLogFeed } from "@/app/ActivityLogs/Components/ActivityLogFeed";
import { ModelType } from "@/gql/graphql";

export function SettingsActivityScreen() {
  const { supplier } = useSettingsSupplier();
  const t = useTranslations("settings.activity");

  if (!supplier) {
    return <NoSupplierEmptyState />;
  }

  return (
    <SettingCard title={t("title")} description={t("description")}>
      <ActivityLogFeed
        modelId={supplier.id}
        modelType={ModelType.Supplier}
        showComposer={false}
      />
    </SettingCard>
  );
}
